import * as ActionTypes from '../constants/ActionTypes';
import { push } from 'react-router-redux';
import { algolia } from 'ui-utilities';
import { CONFIG } from 'ui-utilities';
import { clearEntities, receiveEntities } from './entities';
import { toggleAuthenticationModal } from './auth';
import { setMessage } from './systemMessage';

import { Events } from 'ui-utilities';

const index = new algolia(CONFIG.ALGOLIA_ID, CONFIG.ALGOLIA_KEY);

export const searching = bool => ({
  type: ActionTypes.SEARCHING,
  payload: bool
});

export const showCreate = bool => ({
  type: ActionTypes.SHOW_CREATE,
  value: bool
});

export const setSearchTerm = (term, id) => {
  return dispatch => {
    localStorage.setItem('search', term);

    dispatch({
      type: ActionTypes.SET_SEARCH_ID,
      payload: id
    });

    return dispatch({
      type: ActionTypes.SET_SEARCH_TERM,
      payload: term
    });
  }
};

export const setShowCreate = (result, dispatch) => {
  if(result.hits.length === 0) {
    dispatch(showCreate(true));
  } else {
    dispatch(showCreate(false));
  }

  return result;
};

export const searchForMerchant = location => {
  index.index = CONFIG.ALGOLIA_INDEX;

  return (dispatch, getState) => {
    dispatch(clearEntities('merchant'))

    return index.geoSearch(getState().search.get('currentSearchTerm'), {
      aroundLatLng: [location.toJS().coords.latitude, location.toJS().coords.longitude],
      hitsPerPage: 500,
      page: 0
    }).then(result => setShowCreate(result, dispatch))
      .then(result => dispatch(receiveEntities(result.hits, 'merchant')))
      .then(() => dispatch(searching(false)))
      .catch(err => dispatch(setMessage('error', 'Unable to load Localvore, please check back in a few minutes')));
  }
};

export const searchMerchantsByInvites = (invites, direction = 'invited_vendor_id') => {
  index.index = CONFIG.ALGOLIA_INDEX;

  return (dispatch, getState) => {

    dispatch(clearEntities('merchant'));
    if (invites.size <= 0) return Promise.resolve('No invites');

    return index.merchantIdsSearch('', invites.map(i => i[direction]))
      .then(res => dispatch(receiveEntities(res.hits, 'merchant')));
  }
}

export const searchActiveMerchants = (ids, reset = true) => {
  index.index = CONFIG.ALGOLIA_INDEX;

  return (dispatch, getState) => {
    if (reset) dispatch(clearEntities('merchant'));
    if (ids.size <= 0) return Promise.resolve('No merchants');

    return index.merchantIdsSearch('', ids)
      .then(res => dispatch(receiveEntities(res.hits, 'merchant')));
  }
}

export const selectSuggestion = (value, redirect) => {
  return (dispatch, getState) => {
    dispatch(setSearchTerm(value.get('vendor').get('name'), value.get('vendor_id')));
  }
}

export const searchSubmit = () => {
  return (dispatch, getState) => {
    const { auth, customer, entities, search } = getState();
    const merchant = entities
      .get('merchant')
      .find(m => m.vendor_id === search.get('selectedMerchantId'));

    if (search.get('currentSearchTerm') && customer.get('location').get('place_name')) {
      dispatch(searchForMerchant(
        customer.get('location'), 
        search.get('currentSearchTerm')
      ))
      .then(() => {
        if (auth.get('user').get('isLoggedIn')) {
          if (merchant && !merchant.get('vendor').get('claimed')) { 
            return dispatch(push('/verify'));
          } else if (!merchant) {
            return dispatch(push('/plan'));
          }
        }

        return dispatch(toggleAuthenticationModal());
      })
      .then(res => Events
        .provide('kissmetrics', true)
        .log(
          'record', 
          'Search', { 
            term: search.get('currentSearchTerm'), 
            location: customer.get('location').get('place_name') 
          })
      );
    } else {
      dispatch(setMessage('error', 'Please enter a business name and location'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/search.js